<template>
  <modal-provider
    :fullscreen-breakpoint="601"
    name="comment-modal"
    :width="660"
    :title="modalTitle"
    @before-open="beforeOpen"
  >
    <div class="comment-modal__wrap">
      <QuestionsForm
        v-if="isQuestions"
        :endpoint="endpoint"
        :type="formType"
        :product-id="productId"
      />
      <CommentsForm
        v-else
        :endpoint="endpoint"
        :type="formType"
        :product-id="productId"
      />
    </div>
  </modal-provider>
</template>

<script>
import CommentsForm from './CommentsForm'
import QuestionsForm from '@/components/questions/QuestionsForm.vue'

export default {
  name: 'CommentModal',
  props: {
    isAnswer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      endpoint: '',
      formType: '',
      productId: null,
      isQuestions: false
    }
  },
  components: {
    CommentsForm,
    QuestionsForm
  },
  computed: {
    modalTitle () {
      return this.isQuestions ? this.$t('questions.empty_title') : this.$t('comment.form.title')
    }
  },
  methods: {
    beforeOpen (event) {
      this.endpoint = event.params?.endpoint || ''
      this.formType = event.params?.formType || ''
      this.productId = event.params?.productId || null
      this.isQuestions = event.params?.isQuestions || false
    }
  }
}
</script>

<style scoped lang="sass">

.comment-modal__wrap
  +mmax(1100)
    padding-bottom: 70px

::v-deep
  .modal__title
    margin-bottom: 0
  .review-form__star-wrap
    margin-top: 0
  .review-form__btn-wrap
    margin-bottom: 0
</style>
